export const blogBannerIniValues = {
  title: "",
  banner: "",
  image: "",
  _id: "",
};
